// Mock data for Caprock Logistics Group

export const company = {
  name: 'Caprock Logistics Group',
  short: 'CAPROCK',
  tagline: 'Heavy Haul. Hotshot. Handled.',
  location: 'West Texas, USA',
  phone: '(806) 681-2392',
  email: 'dispatch@caprocklogisticsgroup.com',
  address: 'San Antonio, Texas',
  hours: '24 / 7 Dispatch',
  established: 2011,
};

export const navLinks = [
  { label: 'Services', href: '/services' },
  { label: 'Process', href: '/process' },
  { label: 'About', href: '/about' },
  { label: 'Contact', href: '/contact' },
];

export const heroPhrases = [
  "We'll Get You",
  'On-Time Delivery',
  'Heavy Haul Expertise',
  'Nationwide Coverage',
];

export const services = [
  {
    id: 'flatbed',
    number: '01',
    title: 'Flatbed Freight',
    short: 'Open-deck hauling',
    description:
      'Full-service flatbed transport for construction materials, steel, lumber, pipe, and oversized freight across the continental United States.',
    image:
      'https://images.pexels.com/photos/38095094/pexels-photo-38095094.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  },
  {
    id: 'hotshot',
    number: '02',
    title: 'Oilfield / Hotshot',
    short: 'Fast, dedicated runs',
    description:
      'Rig-up gear, drilling supplies, and time-critical loads delivered on demand.',
    image:
      'https://images.unsplash.com/photo-1557145850-ec56befb224c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwzfHxoZWF2eSUyMGhhdWwlMjB0cnVja2luZ3xlbnwwfHx8YmxhY2t8MTc4NDQ3MTcyOHww&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 'logistics',
    number: '03',
    title: 'Logistics',
    short: 'Freight matched to fleets',
    description:
      'Dedicated dispatch, brokerage, and full-load coordination. We move your freight with the right equipment, the right driver, at the right time.',
    image:
      'https://images.unsplash.com/photo-1571690646273-7d53bbb18898?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwxfHxvaWxmaWVsZCUyMHRydWNrfGVufDB8fHxibGFja3wxNzg0NDcxNzI4fDA&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 'heavy',
    number: '04',
    title: 'Heavy Machinery',
    short: 'Oversize / overweight loads',
    description:
      'Permitted heavy haul for excavators, dozers, cranes, and industrial equipment. Route planning, escorts, and safe delivery every mile.',
    image:
      'https://images.unsplash.com/photo-1660619388248-baec8fd3f973?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwxfHxoZWF2eSUyMGhhdWwlMjB0cnVja2luZ3xlbnwwfHx8YmxhY2t8MTc4NDQ3MTcyOHww&ixlib=rb-4.1.0&q=85',
  },
];

export const attributesRotator = [
  { label: 'The Industry Standard Is', words: ['delayed', 'unreliable', 'opaque'] },
  { label: "What You'll Get With Caprock", words: ['on-time', 'transparent', 'accountable'] },
];

export const process = [
  {
    number: '01',
    title: 'Request A Quote',
    body: 'Send us the origin, destination, dimensions and weight. We reply the same day with rates and available equipment.',
  },
  {
    number: '02',
    title: 'Dispatch & Pickup',
    body: 'A dedicated dispatcher assigns the right driver and trailer. You get real-time tracking from load to delivery.',
  },
  {
    number: '03',
    title: 'Delivered On-Time',
    body: 'Freight arrives safely and on schedule. Paperwork, BOLs and invoicing handled clean — no surprises.',
  },
];

export const stats = [
  { value: '13+', label: 'Years On The Road' },
  { value: '48', label: 'States Covered' },
  { value: '120M+', label: 'Miles Driven' },
  { value: '99.4%', label: 'On-Time Delivery' },
];

export const testimonial = {
  quote:
    'Caprock is our go-to for rig moves, hotshots and heavy equipment. Their dispatch is sharp, their drivers are pros, and the loads always show up when they say they will.',
  author: 'Operations Manager',
  company: 'Basin Drilling Services',
};

export const HERO_VIDEO = '/media/caprock-hero.mp4';

export const CTA_IMAGE =
  'https://images.unsplash.com/photo-1485575301924-6891ef935dcd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwxfHxoaWdod2F5JTIwdHJ1Y2t8ZW58MHx8fGJsYWNrfDE3ODQ0NzE3MzV8MA&ixlib=rb-4.1.0&q=85';

export const HEAVY_IMAGE =
  'https://images.pexels.com/photos/12261472/pexels-photo-12261472.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=940';
